import { Box } from "@mui/system";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { configState } from "../../../../recoil/atoms";
import { BalanceApi, GetStatementResponse } from "../../../../api/payment";
import PatientDiscounts from "../../Discounts/PatientDiscounts/PatientDiscounts";
import { Button, Card, CardContent, LinearProgress, Typography } from "@mui/material";
import { IconFileInvoice, IconReceipt2, IconDiscount2, IconReceipt } from "@tabler/icons";

const commonCardStyle = {
  borderRadius: 3,
  display: "flex",
  justifyContent: "space-around",
  gap: 2,
  alignItems: "center",
  pr: 2,
  mr: 2,
  width: "100%",
  height: "25vh",
};

const flexCardStyle = {
  borderRadius: 3,
  display: "flex",
  justifyContent: "space-around",
  gap: 2,
  alignItems: "center",
  pr: 2,
  mr: 2,
  width: "50%",
  height: "25vh",
};

const PatientBalance = () => {
  let { patientID } = useParams();
  const config = useRecoilValue(configState);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [balance, setBalance] = useState<GetStatementResponse>();
  const [showDiscounts, setShowDiscounts] = useState<boolean>(false);

  const handleChange = () => {
    setShowDiscounts(!showDiscounts);
  };

  const getBalance = () => {
    const Balance = new BalanceApi(config);
    Balance
      .getBalanceStatement(patientID!)
      .then((res) => {        
        setBalance(res?.data);
      })
      .catch((err) => {        
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <>
      {!isLoading ? (
        <>
          <Box display="flex" sx={{ mb: 2, flexWrap: window.innerWidth <= 700 ? "wrap" : "nowrap", gap: 0.5 }}>
            <Card sx={commonCardStyle}>
              <CardContent>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h4" component="div" sx={{ mb: 5 }}>
                    Total Balance
                  </Typography>
                  <Typography variant="h2" color={"secondary"}>
                   $ {balance?.total}
                  </Typography>
                </Box>
              </CardContent>
              <Typography style={{ fontSize: "40px" }}>
                <IconReceipt2 />
              </Typography>
            </Card>
            <Card sx={flexCardStyle}>
              <CardContent>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h4" component="div" sx={{ mb: 5 }}>
                    Discounts
                  </Typography>

                  <Button onClick={handleChange}>
                    <Typography variant="h3" color={"secondary"}>
                     {!showDiscounts ? "View" : "Hide"} Discounts
                    </Typography>
                  </Button>
                </Box>
              </CardContent>
              <Typography style={{ fontSize: "40px" }}>
                <IconDiscount2 />
              </Typography>
            </Card>
            <Card sx={flexCardStyle}>
              <CardContent>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h4" component="div" sx={{ mb: 5 }}>
                    Bills
                  </Typography>
                  <Link to={`/patient/${patientID}/bills`} style={{ textDecoration: "none" }}>
                    <Typography variant="h3" color={"secondary"}>
                      View Bills
                    </Typography>
                  </Link>
                </Box>
              </CardContent>
              <Typography style={{ fontSize: "40px" }}>
                <IconFileInvoice />
              </Typography>
            </Card>
            <Card sx={flexCardStyle}>
              <CardContent>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="h4" component="div" sx={{ mb: 5 }}>
                    Receipts
                  </Typography>
                  <Link to={`/patient/${patientID}/receipts`} style={{ textDecoration: "none" }}>
                    <Typography variant="h3" color={"secondary"}>
                      View Receipts
                    </Typography>
                  </Link>
                </Box>
              </CardContent>
              <Typography style={{ fontSize: "40px" }}>
                <IconReceipt />
              </Typography>
            </Card>
          </Box>
          <PatientDiscounts showDiscounts={showDiscounts} PatientID={patientID}/>
        </>
      ) : (
        <LinearProgress color="secondary" />
      )}
    </>
  );
};

export default PatientBalance;
